<template>
  <el-container direction='vertical'>
    <div class="nut-tab-title">
      <span
        @click="tabSwitch(1)"
        :class="current === 1 ? 'nut-tab-active' :''"
        class="nut-title-nav-list "
      >
        <a
          href="javascript:void(0)"
          class="nut-tab-link"
        >有效劵</a></span>
      <span
        @click="tabSwitch(2)"
        :class="current === 2 ? 'nut-tab-active' :''"
        class="nut-title-nav-list "
      >
        <a
          href="javascript:void(0)"
          class="nut-tab-link"
        >无效劵</a>
      </span>
    </div>
    <div v-if="current===1" class="v-nut-infiniteloading">
      <div class="stamp" v-for="(item,i) in couponListData" :key='i'>
        <div class="par">
          <div class="stamp-top">{{item.coupon_name}}<span v-if="item.from==='1'">（满减劵）</span></div>
          <div class="stamp-cdkey">兑换码<span> {{item.cdkey}}</span>
            <div
              class="stamp-btn"
              @click="item.show = !item.show"
            ><span>详情</span>
              <i
                v-if="!item.show"
                class="el-icon-arrow-down"
              ></i>
              <i
                v-if="item.show"
                class="el-icon-arrow-up"
              ></i>
            </div>
          </div>
          <div class="stamp-bom01">{{item.starttime}}</div>
          <div class="stamp-bom02">{{item.endtime}}</div>
        </div>
        <div
          v-if="isUndue(item.starttime)"
          class="tip-coupon isUndue"
        >
          <div class="tip-coupon-quan">未到期</div>
        </div>
        <div
          v-if="item.status ==='1'"
          class="tip-coupon"
        >
          <div class="tip-coupon-quan">已使用</div>
        </div>
        <div
          v-if="item.status ==='3'"
          class=" tip-coupon"
        >
          <div class="tip-coupon-quan">已过期</div>
        </div>
        <div
          v-if="item.status ==='2'"
          class="tip-coupon"
        >
          <div class="tip-coupon-quan">已作废</div>
        </div>
        <div
          @click="requestUse(item)"
          class="stamp-copy"
        >点击使用</div>
        <div
          v-if="item.show"
          class="stamp-description"
        >{{item.coupon_description}}</div>
      </div>
      <p v-if="couponListData.length === 0" class="v-tip">暂无数据</p>
      <p v-if="isHasMore" @click="onInfinite" class="v-more" ><nut-icon type="down" color="#848484"></nut-icon></p>

    </div>
    <div v-if="current===2" class="v-nut-infiniteloading">
      <div class="stamp" v-for="(item,i) in couponListDataUnless" :key='i'>
        <div class="par">
          <div class="stamp-top">{{item.coupon_name}}<span v-if="item.from==='1'">（满减劵）</span></div>
          <div class="stamp-cdkey">兑换码<span> {{item.cdkey}}</span>
            <div
              class="stamp-btn"
              @click="item.show = !item.show"
            ><span>详情</span>
              <i
                v-if="!item.show"
                class="el-icon-arrow-down"
              ></i>
              <i
                v-if="item.show"
                class="el-icon-arrow-up"
              ></i>
            </div>
          </div>
          <div class="stamp-bom01">{{item.starttime}}</div>
          <div class="stamp-bom02">{{item.endtime}}</div>
        </div>
        <div
          v-if="isUndue(item.starttime)"
          class="tip-coupon isUndue"
        >
          <div class="tip-coupon-quan">未到期</div>
        </div>
        <div
          v-if="item.status ==='1'"
          class="tip-coupon"
        >
          <div class="tip-coupon-quan">已使用</div>
        </div>
        <div
          v-if="item.status ==='3'"
          class=" tip-coupon"
        >
          <div class="tip-coupon-quan">已过期</div>
        </div>
        <div
          v-if="item.status ==='2'"
          class="tip-coupon"
        >
          <div class="tip-coupon-quan">已作废</div>
        </div>
        <div
          v-if="item.show"
          class="stamp-description"
        >{{item.coupon_description}}</div>
      </div>
      <p v-if="couponListDataUnless.length === 0" class="v-tip">暂无数据</p>
      <p v-if="isHasMoreUnless" @click="onInfiniteUnless" class="v-more"><nut-icon type="down" color="#848484"></nut-icon></p>
    </div>
  </el-container>
</template>
<script>
import {
  getCouponList,
  getWebsocketToken
} from '@/views/mobile/CouponList/apis'
export default {
  data () {
    return {
      couponListData: [],
      page: 1,
      size: 10,
      pageAll: 0,
      isHasMore: false,
      couponListDataUnless: [],
      pageUnless: 1,
      sizeUnless: 10,
      pageAllUnless: 0,
      isHasMoreUnless: false,
      timestamp: new Date().getTime(),
      isClick: true,
      token: '',
      activeCouponInfo: {},
      current: 1,
      shopName: ''
    }
  },
  methods: {
    tabSwitch (index) {
      this.current = index
    },
    isUndue (value) {
      let times = new Date(value).getTime()
      let timesCurrent = new Date().getTime()
      if (parseInt(times) > parseInt(timesCurrent)) {
        return true
      } else {
        return false
      }
    },
    isOverdue (value) {
      let times = new Date(value).getTime()
      let timesCurrent = new Date().getTime()
      if (parseInt(times) < parseInt(timesCurrent)) {
        return true
      } else {
        return false
      }
    },
    // 有效劵
    onInfinite () {
      this.page = this.page + 1
      this.requestCouponList()
    },
    // 无效劵
    onInfiniteUnless () {
      this.pageUnless = this.pageUnless + 1
      this.requestCouponListUnless()
    },
    // 有效劵
    requestCouponList () {
      this.loading = this.$toast.loading()
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      data.append('page', this.page)
      data.append('size', this.size)
      data.append('status', '0')
      getCouponList(data)
        .then((result) => {
          this.loading.hide()
          if (result) {
            let resultList = result.data.list
            resultList.forEach((element) => {
              element.show = false
            })
            this.couponListData = this.couponListData.concat(resultList)
            this.pageAll = result.data.pager.pages
            if (this.page < this.pageAll) {
              this.isHasMore = true
            } else {
              this.isHasMore = false
            }
          }
        })
        .catch((error) => {
          if (error) {
            this.loading.hide()
          }
        })
    },
    // 无效劵
    requestCouponListUnless () {
      this.loading = this.$toast.loading()
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      data.append('page', this.pageUnless)
      data.append('size', this.sizeUnless)
      data.append('status', '1,2,3')
      getCouponList(data)
        .then((result) => {
          this.loading.hide()
          if (result) {
            let resultList = result.data.list
            resultList.forEach((element) => {
              element.show = false
            })
            this.couponListDataUnless =
              this.couponListDataUnless.concat(resultList)
            this.pageAllUnless = result.data.pager.pages
            if (this.pageUnless < this.pageAllUnless) {
              this.isHasMoreUnless = true
            } else {
              this.isHasMoreUnless = false
            }
          }
        })
        .catch((error) => {
          if (error) {
            this.loading.hide()
          }
        })
    },
    requestUse (obj) {
      if (obj.status === '1') {
        this.$toast.warn('已使用')
        return
      }
      if (obj.status === '3') {
        this.$toast.warn('已过期')
        return
      }
      if (this.isUndue(obj.starttime)) {
        this.$toast.warn('未到期')
        return
      }
      if (obj.status === '2') {
        this.$toast.warn('已作废')
        return
      }
      let title = obj.coupon_name
      let that = this
      this.isClick = true
      this.$dialog({
        id: 'use-dialog',
        title: title,
        content: '请移步收银台，工作人员协助使用！',
        closeBtn: true,
        onOkBtn (event) {
          this.close()
          if (that.isClick) {
            that.activeCouponInfo = obj
            that.requestPreuse()
            that.isClick = false
          } else {
            return false
          }
        }
      })
    },
    requestPreuse () {
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      window.wscoupon1.send(
        JSON.stringify({
          token: this.token,
          action: 'coupon_use',
          mcid: this.activeCouponInfo.id
        })
      )
    },
    // 获取WebsocketToken
    requestWebsocketToken (tokenType) {
      getWebsocketToken().then((result) => {
        if (result) {
          let that = this
          let token = result.data.token
          let host = result.data.host
          let port = result.data.port
          this.token = token
          if (!window.wscoupon1) {
            window.wscoupon1 = new WebSocket(
              (window.location.protocol === 'https:' ? 'wss' : 'ws') +
                '://' +
                host +
                ':' +
                port
            )
          } else {
            if (window.wscoupon1.readyState !== 1) {
              window.wscoupon1 = new WebSocket(
                (window.location.protocol === 'https:' ? 'wss' : 'ws') +
                  '://' +
                  host +
                  ':' +
                  port
              )
            }
          }
          window.wscoupon1.onopen = function () {
            window.wscoupon1.send(
              JSON.stringify({
                token: token,
                action: 'register'
              })
            )
          }
          window.wscoupon1.onmessage = function (evt) {
            let info = JSON.parse(evt.data)
            if (
              info &&
              info.msgType === 'register' &&
              info.msgBody === 'success'
            ) {
              console.log('连接成功')
              if (tokenType === 'refresh') {
                that.requestPreuse()
              }
            }
            if (
              info &&
              info.msgType === 'AUTH' &&
              info.msgBody === 'Token expired'
            ) {
              that.requestWebsocketToken('refresh')
            }
            if (
              info &&
              info.msgType === 'coupon_use' &&
              info.msgBody === 'success'
            ) {
              if (that.shopName === 'hzhb') {
                that.$toast.success('优惠劵已使用')
                that.couponListData = []
                that.couponListDataUnless = []
                that.requestCouponListUnless()
                that.requestCouponList()
                return
              }
              that.loadingCoupon = that.$toast.loading('等待后台确认...')
            }
            if (
              info &&
              info.msgType === 'coupon_use' &&
              info.msgBody !== 'success'
            ) {
              this.$toast.warn(info.msgBody)
            }
            if (info && info.msgType === 'coupon_sure') {
              that.loadingCoupon.hide()
              that.$dialog({
                id: 'use-success-dialog',
                closeBtn: false,
                noCancelBtn: true,
                okBtnTxt: '我知道了',
                title: '温馨提示',
                content: '后台已经确认！',
                onOkBtn (event) {
                  this.close()
                }
              })
              that.couponListData = []
              that.couponListDataUnless = []
              that.requestCouponListUnless()
              that.requestCouponList()
            }
          }
          window.wscoupon1.onclose = function () {
            console.log('onclose')
            // 关闭 websocket
          }
        }
      })
    }
  },
  mounted () {
    this.requestCouponList()
    this.requestCouponListUnless()
    this.requestWebsocketToken(null)
  },
  created () {
    let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'))
    let shop = window.location.hostname.split('.')[0]
    this.shopName = shop
    console.log(userInfo)
    if (shop === 'szty') {
      document.title = '陶源酒家'
    } else if (userInfo.ext.shopname !== '') {
      document.title = userInfo.ext.shopname
    } else {
      document.title = '香港富临皇宫'
    }
  }
}
</script>
<style lang="less">
#use-dialog {
  .nut-dialog-ok {
    background: linear-gradient(315deg, #68c937 0%, #67c23a 100%) !important;
  }
  .nut-dialog-ok:active {
    background: inherit;
  }
}
#use-success-dialog {
  .nut-dialog-ok:active {
    background: inherit;
  }
}
.v-nut-infiniteloading {
  padding: 8px;
  margin-top: 50px;
}
.v-tip {
  position: absolute;
  top: 36%;
  color: #848484;
  width: 100%;
  text-align: center;
  left: 0;
}
.v-more{
  text-align: center;
  cursor: pointer;
}
.stamp {
  margin-bottom: 16px;
  position: relative;
  cursor: pointer;
  width: 100%;
  overflow: hidden;
  background: #fcffba;
  .par {
    margin-right: 60px;
    background: #e82a36;
    color: #fcffba;
    box-sizing: border-box;
    padding: 12px;
    position: relative;
    .stamp-btn {
      font-size: 12px;
      position: absolute;
      top: 0;
      right: 0;
    }
    .stamp-top {
      font-size: 18px;
      font-weight: 600;
    }
    .stamp-cdkey {
      margin-top: 4px;
      font-size: 13px;
      position: relative;
    }
    .stamp-bom01 {
      margin-top: 4px;
      font-size: 13px;
    }
    .stamp-bom02 {
      margin-top: 4px;
      font-size: 13px;
    }
  }
  .stamp-copy {
    height: 106px;
    width: 60px;
    position: absolute;
    right: 0;
    top: 23px;
    color: #e82a36;
    font-size: 22px;
    text-align: center;
  }
  .stamp-description {
    background: #eee;
    font-size: 12px;
    padding: 8px;
  }
}

.coupon-list {
  margin-bottom: 16px;
  background-image: url(assets/images/yhj02.png);
  background-position: center;
  background-repeat: no-repeat;
  // background-size: cover;
  background-size: 100% 100%;
  border-radius: 4px;
  position: relative;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 24px 0;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  .btn-coupon-quan {
    height: 40px;
    width: 80px;
    position: absolute;
    right: 16px;
    line-height: 40px;
    text-align: center;
    color: #f00;
    cursor: pointer;
    top: 32px;
  }
}
.tip-coupon {
  width: 60px;
  height: 60px;
  position: absolute;
  right: 0px;
  top: 20px;
  border-radius: 50%;
  padding: 4px;
  border: 2px solid #333;
  box-sizing: border-box;
  .tip-coupon-quan {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid #333;
    color: #333;
    transform: rotate(45deg);
    text-align: center;
    line-height: 46px;
    font-size: 13px;
    font-weight: 600;
  }
}
.tip-coupon.green {
  border: 3px solid #67c23a;
  .tip-coupon-quan {
    box-sizing: border-box;
    border: 2px solid #67c23a;
    color: #67c23a;
  }
}
.tip-coupon.isUndue {
  border: 3px solid rgb(224, 138, 39);
  .tip-coupon-quan {
    box-sizing: border-box;
    border: 2px solid rgb(224, 138, 39);
    color: rgb(224, 138, 39);
  }
}
.list-top {
  margin-left: 36px;
  color: #67c23a;
  // color: #fff;
  font-size: 18px;
  line-height: 24px;
}
.list-bom {
  margin-left: 36px;
  font-size: 13px;
  margin-top: 8px;
}
.list-xq {
  margin-left: 36px;
  margin-right: 16px;
  margin-top: 8px;
  font-size: 12px;
}
.list-cdkey {
  // float: right;
  // margin-right: 16px;
  margin-left: 36px;
  margin-top: 8px;
  font-size: 14px;
  span {
    font-size: 16px;
    // color: #f00;
    color: #67c23a;
  }
}
.wrapper-mobile {
  .nut-tab {
    padding: 0;
  }
  .nut-cell-box {
    // padding: 0.12rem 0;
    padding: 12px 0;
  }
  .nut-tab-title {
    border: 0;
    position: fixed;
    margin: 0 auto;
    top: 0;
    left: 0;
    // height: 0.5rem;
    height: 50px;
    margin: 0 auto;
    z-index: 1000;
  }
  .nut-tab-item {
    height: auto;
    margin-top: 50px;
    // margin-top: 0.5rem;
  }
  .nut-title-nav-list {
    border-bottom: 1px solid #ededed;
  }
  .nut-tab-link {
    // font-size: 0.15rem;
    font-size: 16px;
  }
  .nut-tab-active {
    border-bottom: 1px solid red;
    .nut-tab-link {
      color: red;
      font-weight: 200;
      // font-size: 0.15rem;
      font-size: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/CouponList/index.vue